import React, { useEffect, useRef } from "react";
import Select, { components } from "react-select";
import { Modal } from "react-bootstrap";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaPlus,
  FaUndo,
  FaSave,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { getRetailerSlice } from "../../../store/slices/retailerSlice";
import AddUpdateRetailerModal from "../../components/retailer/addUpdateRetailer";
import { getCountrySlice } from "../../../store/slices/countrySlice";
import { getDistricSlice } from "../../../store/slices/districtSlice";
import { getCitySlice } from "../../../store/slices/citySlice";
import {
  addRetailerSlice,
  resetAddRetailerMessage,
} from "../../../store/slices/retailerSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import showTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import styles from "./pharmaSalesRetailer.module.scss";
import AsyncSelect from "react-select/async";
import { getAllStockSlice } from "../../../store/slices/stockInventorySlice";
const AddUpdatePharmaSalesRetailer = ({
  showModal,
  setShowModal,
  handleAddUpdate,
  isMode,
  handleSelectChange,
  state,
  medicines,
  salesFormData,
  setSalesFormData,
  handlePlaceChange,
  modalAction,
  accountType,
  bank,
  setPaymentStatus,
}) => {
  const [medicineRows, setMedicineRows] = useState([
    {
      medicine: null,
      quantity: "",
      freeQuantity: "",
      totalQuantity: "",
      mrp: "",
      rmrp: "",
      margin: "",
      rate: "",
      taxable: "",
      cgst: "",
      sgst: "",
      discount: "",
      discountValue: "",
      total: "",
      stockId: "",
      batchNumber: "",
      expiryDate: "",
      isRefundEditing: false,
      refundReason: "",
      refundQty: "",
    },
  ]);

  const [netTotal, setNetTotal] = useState("0.00");
  const [showRetailerModal, setShowRetailerModal] = useState(false);
  const [retailerFormData, setRetailerFormData] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { userInfo, token } = useSelector((state) => state.auth);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    passport: false,
    aadhar: false,
  });
  const resetForm = () => {
    setRetailerFormData({
      clinicId: clinicId,
      userType: 1,
      name: "",
      email: "",
      phone: "",
      alternate_Phone: "",
      city: "",
      cityName: "",
      country: "",
      countryName: "",
      state: "",
      stateName: "",
    });
  };
  const { districts } = useSelector((state) => state.district);
  const { cities } = useSelector((state) => state.city);
  const { Country } = useSelector((state) => state.country);
  const dispatch = useDispatch();
  useEffect(() => {
    if (clinicId) {
      dispatch(getRetailerSlice({ clinicId, token }));
    }
  }, [dispatch, clinicId, token]);

  useEffect(() => {
    dispatch(getCountrySlice({ status: ["Active"], token }));
  }, [dispatch, token]);

  useEffect(() => {
    if (showModal && modalAction === "create") {
      setMedicineRows([
        {
          medicine: null,
          quantity: "",
          freeQuantity: "",
          totalQuantity: "",
          mrp: "",
          rmrp: "",
          rate: "",
          discount: "",
          discountValue: "",
          margin: "",
          taxable: "",
          cgst: "",
          sgst: "",
          total: "",
          stockId: "",
          batchNumber: "",
          expiryDate: "",
          isRefundEditing: false,
          refundReason: "",
          refundQty: "",
        },
      ]);
      setNetTotal("0.00");
      setSalesFormData({
        retailerId: "",
        retailerName: "",
        prescribedBy: "",
        placeOfSupply: "",
        placeOfSupplyName: "",
        accountType: "",
        accountTypeName: "",
        bank: "",
        bankName: "",
        paymentStatus: "UNPAID",
        isAlreadyPaid: false,
      });
    }
  }, [showModal, modalAction]);

  const handleMedicineChange = (selectedOption, index) => {
    const selectedMedicine = medicines.find(
      (med) => med._id === selectedOption.value,
    );

    const updatedRows = [...medicineRows];
    updatedRows[index].medicine = selectedOption;
    updatedRows[index].stockId = selectedOption?.value || "";
    updatedRows[index].mrp = selectedMedicine?.mrp || "";
    updatedRows[index].rmrp = selectedMedicine?.rmrp || "";
    updatedRows[index].batchNumber = selectedMedicine?.batchNumber || "";
    updatedRows[index].expiryDate = selectedMedicine?.expiryDate || "";
    updatedRows[index].taxRate = selectedMedicine?.taxRate || "";

    const qty = parseFloat(updatedRows[index]?.quantity) || 0;
    
    const freeQuantity = parseFloat(updatedRows[index]?.freeQuantity) || 0;
    const margin = parseFloat(updatedRows[index]?.margin) || 0;
    const discount = parseFloat(updatedRows[index]?.discount) || 0;
    // const rate = parseFloat(updatedRows[index]?.rate) || 0;
    const rmrp = parseFloat(updatedRows[index]?.rmrp) || parseFloat(updatedRows[index]?.mrp) || 0;
    const mrp = parseFloat(updatedRows[index]?.mrp) || 0;
    const taxRate = parseFloat(updatedRows[index]?.taxRate) || 0;
    const rate = rmrp - (rmrp * margin) / 100;
    updatedRows[index].rate = rate.toFixed(2);

    const gross = qty * rate;

    const discountAmount = (gross * discount) / 100;
    const taxable = gross - discountAmount;

    const taxAmount = (gross - discountAmount) * (taxRate / 100);
    const cgst = taxAmount / 2;
    const sgst = taxAmount / 2;
    const total = taxable + cgst + sgst;

    updatedRows[index].discountValue = discountAmount.toFixed(2);
    updatedRows[index].cgst = cgst.toFixed(2);
    updatedRows[index].sgst = sgst.toFixed(2);
    updatedRows[index].taxable = taxable.toFixed(2);
    updatedRows[index].total = total.toFixed(2);
    updatedRows[index].totalQuantity = (qty + freeQuantity).toFixed(2);

    setMedicineRows(updatedRows);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedRows = [...medicineRows];
    updatedRows[index][field] = value;

    const qty = parseFloat(updatedRows[index]?.quantity) || 0;
    
    const freeQuantity = parseFloat(updatedRows[index]?.freeQuantity) || 0;
    const rmrp = parseFloat(updatedRows[index]?.rmrp) || 0;
    const margin = parseFloat(updatedRows[index]?.margin) || 0;
    const rate = parseFloat(updatedRows[index]?.rate) || 0;
    const discount = parseFloat(updatedRows[index]?.discount) || 0;
    const taxRate = parseFloat(updatedRows[index]?.taxRate) || 0;

    /* ---------- MARGIN → RATE ---------- */
    if (field === "margin") {
      const basePrice = rmrp / (1 + taxRate / 100);
      const newRate = basePrice - (basePrice * margin) / 100;
      updatedRows[index].rate = newRate.toFixed(2);
    }

    /* ---------- TOTAL CALCULATION ---------- */
    if (
      field === "margin" ||
      field === "quantity" ||
      field === "rate" ||
      field === "discount"
    ) {
      const finalRate = parseFloat(updatedRows[index]?.rate) || 0;

      const gross = qty * finalRate;
      const discountAmount = (gross * discount) / 100;
      const taxable = gross - discountAmount;

      const taxAmount = (gross - discountAmount) * (taxRate / 100);
      const cgst = taxAmount / 2;
      const sgst = taxAmount / 2;
      const total = taxable + cgst + sgst;
      updatedRows[index].cgst = cgst.toFixed(2);
      updatedRows[index].sgst = sgst.toFixed(2);
      updatedRows[index].taxable = taxable.toFixed(2);
      updatedRows[index].discountValue = discountAmount.toFixed(2);
      updatedRows[index].total = total.toFixed(2);
      updatedRows[index].totalQuantity = (qty + freeQuantity).toFixed(2);
    }

    /* ---------- REFUND CALCULATION ---------- */
    if (field === "refundQty") {
      const discountValue = parseFloat(salesFormData?.discount) || 0;
      const subTotal = parseFloat(salesFormData?.subTotal) || 0;

      const discountPercent =
        subTotal > 0 ? (discountValue / subTotal) * 100 : 0;

      const refundQty = parseFloat(value) || 0;
      const refundRate = parseFloat(updatedRows[index]?.rate) || 0;

      const rawAmount = refundQty * refundRate;
      const discountAmount = (rawAmount * discountPercent) / 100;
      const finalRefundAmount = rawAmount - discountAmount;

      updatedRows[index].refundAmount = finalRefundAmount.toFixed(2);
    }

    setMedicineRows(updatedRows);
  };

  const addMedicineRow = () => {
    setMedicineRows([
      ...medicineRows,
      {
        medicine: null,
        quantity: "",
        freeQuantity: "",
        totalQuantity: "",
        mrp: "",
        rmrp: "",
        margin: "",
        rate: "",
        cgst: "",
        sgst: "",
        taxable: "",
        discount: "",
        discountValue: "",
        total: "",
        stockId: "",
        batchNumber: "",
        expiryDate: "",
        isRefundEditing: false,
        refundReason: "",
        refundQty: "",
      },
    ]);
  };

  const removeMedicineRow = (index) => {
    const updatedRows = medicineRows?.filter((_, i) => i !== index);
    setMedicineRows(updatedRows);
  };

  const calculateSubtotal = () => {
    return medicineRows?.reduce((acc, row) => {
      const total = parseFloat(row?.total) || 0;
      return acc + total;
    }, 0);
  };

  useEffect(() => {
    if (
      modalAction === "edit" ||
      (modalAction === "refund" &&
        salesFormData?.items?.length > 0 &&
        medicines?.length)
    ) {
      const transformedRows = salesFormData?.items?.map((item) => {
        const med = medicines?.find((m) => m?._id === item.stockId?._id);

        return {
          medicine: med
            ? { value: med?._id, label: med?.name }
            : {
                value: item?.stockId?._id || "",
                label: item?.stockId?.name || "Unknown",
              },
          stockId: item?.stockId || "",
          quantity: item?.quantity || "",
          freeQuantity: item?.freeQuantity || "",
          rate: item?.rate || "",
          mrp: med?.mrp || "",
          rmrp: med?.rmrp || "",
          margin: item?.margin || "",
          cgst: item?.cgst || "",
          sgst: item?.sgst || "",
          taxable: item?.taxable || "",
          total: item?.total || "",
          discount: item?.discount || "",
          batchNumber: item?.batchNumber || "",
          expiryDate: item?.expiryDate || "",
          refundQty: item?.returnedQuantity || "",
          refundAmount: item?.returnedPrice || "",
          refundStatus: item?.returnStatus || "Not Returned",
        };
      });

      setMedicineRows(transformedRows);
      setNetTotal(salesFormData?.afterDiscount || "");
    }
  }, [modalAction, salesFormData, medicines]);

  const filteredBanks = salesFormData?.accountType
    ? bank?.filter(
        (b) =>
          b?.accountType && b?.accountType._id === salesFormData?.accountType,
      )
    : [];

  const handleChange = (e) => {
    if (e.dob && e.age) {
      setRetailerFormData((prev) => ({
        ...prev,
        dob: e.dob,
        age: e.age,
      }));
    } else {
      const { name, value } = e.target;
      setRetailerFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleRetailerSelectChange = async (selectedOption, name) => {
    if (name === "country") {
      setRetailerFormData((prevData) => ({
        ...prevData,
        country: selectedOption.value,
        countryName: selectedOption.label,
        state: "",
        stateName: "",
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      // await dispatch(getStateSlice({ countryId: selectedOption.value, token }));
    } else if (name === "state") {
      setRetailerFormData((prevData) => ({
        ...prevData,
        state: selectedOption.value,
        stateName: selectedOption.label,
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      await dispatch(getDistricSlice({ stateId: selectedOption.value, token }));
    } else if (name === "district") {
      setRetailerFormData((prevData) => ({
        ...prevData,
        district: selectedOption.value,
        districtName: selectedOption.label,
        city: "",
        cityName: "",
      }));
      await dispatch(
        getCitySlice({
          countryId: retailerFormData.country,
          stateId: retailerFormData.state,
          districtId: selectedOption.value,
          token,
        }),
      );
    } else if (name === "city") {
      setRetailerFormData((prevData) => ({
        ...prevData,
        city: selectedOption.value,
        cityName: selectedOption.label,
      }));
    } else {
      setRetailerFormData((prev) => ({
        ...prev,
        [name]: selectedOption.value,
      }));
    }
  };

  const handleFileChange = (file) => {
    if (file) {
      setRetailerFormData((prevData) => ({
        ...prevData,
        patient_image: file,
      }));
    }
  };

  const handleAddRetailer = async (e) => {
    e.preventDefault();
    const requiredFields = ["gender", "country", "state", "district", "city"];
    const errors = {};

    requiredFields.forEach((field) => {
      if (!retailerFormData[field]) {
        errors[field] = `Please select ${field}`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    const { name, email, phNumber, aadhar, passport } = inputError;
    if (name || email || phNumber || aadhar || passport) {
      return;
    }
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("clinicId", clinicId);
      formDataToSend.append("clinicUserId", userInfo?._id);
      formDataToSend.append("name", retailerFormData?.name || "");
      formDataToSend.append("email", retailerFormData?.email || "");
      formDataToSend.append("phone", retailerFormData?.phone || "");
      formDataToSend.append(
        "alternate_Phone",
        retailerFormData?.alternate_Phone || "",
      );
      formDataToSend.append("userType", 1);
      formDataToSend.append("gender", retailerFormData?.gender || "");
      formDataToSend.append("dob", retailerFormData?.dob || "");
      formDataToSend.append("HC_number", retailerFormData?.HC_number || "");
      formDataToSend.append(
        "aadhar_number",
        retailerFormData?.aadhar_number || "",
      );
      formDataToSend.append("passport", retailerFormData?.passport || "");
      formDataToSend.append("blood_group", retailerFormData?.blood_group || "");
      formDataToSend.append("status", retailerFormData?.status || "");
      formDataToSend.append(
        "membership_group",
        retailerFormData?.membership_group || "",
      );
      formDataToSend.append("country", retailerFormData?.country || "");
      formDataToSend.append("state", retailerFormData?.state || "");
      formDataToSend.append("city", retailerFormData?.city || "");
      formDataToSend.append("district", retailerFormData?.district || "");
      const response = await dispatch(
        addRetailerSlice({ formDataToSend, token }),
      );
    } catch (error) {
      console.error("Error details:", error);
    }
  };

  const loadRetailerOptions = async (inputValue) => {
    try {
      const res = await dispatch(
        getRetailerSlice({
          clinicId,
          name: inputValue,
          token,
        }),
      );

      const retailerList = res?.payload?.result.list || [];

      const options = retailerList.map((r) => ({
        value: r?._id,
        label: r?.name,
      }));

      return [
        ...options,
        {
          value: "add_new",
          label: "Add New Retailer",
          isAddNew: true,
        },
      ];
    } catch (error) {
      return [];
    }
  };

  const CustomOption = (props) => {
    const { data } = props;

    if (data.isAddNew) {
      return (
        <div
          {...props.innerProps}
          className="px-3 py-2 text-primary d-flex align-items-center"
          style={{ cursor: "pointer" }}
        >
          <FaPlus className="me-2" />
          Add New Retailer
        </div>
      );
    }

    return <components.Option {...props} />;
  };

  const loadMedicineOptions = async (inputValue) => {
    const response = await dispatch(
      getAllStockSlice({
        clinicId,
        token,
        search: inputValue,
        limit: 10,
        currentPage: 1,
      }),
    );

    const data = response?.payload?.result?.list || [];

    return data
      .filter((item) => item.quantity > 0)
      .map((item) => ({
        value: item._id,
        label: `${item.name} (${item.quantity})`,
      }));
  };

  return (
    <>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        fullscreen
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {modalAction === "edit" || modalAction === "refund"
              ? "UPDATE SALES"
              : "ADD SALES"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAddUpdate({
                medicineRows,
                // discountType,
                // discountValue,
              });
            }}
          >
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Retailer Name</label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    loadOptions={loadRetailerOptions}
                    placeholder="Search Retailer"
                    components={{ Option: CustomOption }}
                    value={
                      salesFormData?.retailerName
                        ? {
                            value: salesFormData?.retailerId,
                            label: salesFormData?.retailerName,
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption?.value === "add_new") {
                        setShowModal(false);
                        setShowRetailerModal(true);
                        resetForm();
                      } else {
                        handleSelectChange(selectedOption, "retailer");
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Place Of Supply</label>
                  <Select
                    name="placeOfSupply"
                    value={
                      salesFormData?.placeOfSupply
                        ? {
                            value: salesFormData?.placeOfSupply,
                            label: salesFormData?.placeOfSupplyName,
                          }
                        : null
                    }
                    placeholder="Select Place"
                    onChange={(selectedOption) =>
                      handlePlaceChange(selectedOption, "placeOfSupply")
                    }
                    options={state?.map((item) => ({
                      value: item?._id,
                      label: item?.gstCode
                        ? `${item?.gstCode} - ${item?.name}`
                        : `${item?.name}`,
                    }))}
                    isDisabled={
                      modalAction === "edit" || modalAction === "refund"
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label d-block">
                    Payment Status
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentStatus"
                      id="Paid"
                      value="PAID"
                      checked={salesFormData?.paymentStatus === "PAID"}
                      onChange={(e) => setPaymentStatus(e?.target?.value)}
                      disabled={salesFormData?.isAlreadyPaid === true}
                    />
                    <label className="form-check-label" htmlFor="Paid">
                      Paid
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="paymentStatus"
                      id="Unpaid"
                      value="UNPAID"
                      checked={salesFormData?.paymentStatus === "UNPAID"}
                      onChange={(e) => setPaymentStatus(e?.target?.value)}
                      disabled={salesFormData?.isAlreadyPaid === true}
                    />
                    <label className="form-check-label" htmlFor="Unpaid">
                      Unpaid
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="col-form-label">Account Type:</label>
                    <Select
                      value={
                        salesFormData?.accountType
                          ? {
                              value: salesFormData?.accountType,
                              label: salesFormData?.accountTypeName,
                            }
                          : null
                      }
                      placeholder="Select Account Type"
                      options={accountType?.map((account) => ({
                        value: account?._id,
                        label: account?.name,
                      }))}
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "accountType")
                      }
                      isDisabled={
                        salesFormData?.paymentStatus !== "PAID" ||
                        salesFormData?.isAlreadyPaid === true
                      }
                    />
                  </div>
                </div>

                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="col-form-label">Bank:</label>
                    <Select
                      required
                      value={
                        salesFormData?.bank
                          ? {
                              value: salesFormData?.bank,
                              label: salesFormData?.bankName,
                            }
                          : null
                      }
                      placeholder="Select Bank"
                      options={filteredBanks?.map((b) => ({
                        value: b?._id,
                        label: b?.name,
                      }))}
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "bank")
                      }
                      isDisabled={
                        !salesFormData?.accountType ||
                        salesFormData?.isAlreadyPaid === true
                      }
                    />
                  </div>
                </div>
                {/* )} */}
              </div>

              <div className="mt-4">
                <h6>Medicines</h6>
                <div className={styles.pharmaTableWrapper}>
                  <table className="table table-bordered align-middle">
                    <thead className="table-light">
                      <tr>
                        <th
                          style={{
                            width: modalAction === "refund" ? "15%" : "15%",
                          }}
                        >
                          Name
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Batch No.
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "5%" : "5%",
                          }}
                        >
                          Exp Dt
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Qty
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          Free
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          MRP
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          RMRP
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          Margin(%)
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Rate
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          Disc(%)
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Taxable
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          CGST
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          SGST
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "10%" : "11%",
                          }}
                        >
                          Total
                        </th>
                        {modalAction === "refund" && (
                          <th style={{ width: "7%" }}>Refund Status</th>
                        )}
                        {modalAction !== "edit" && (
                          <th style={{ width: "7%" }}>Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {medicineRows?.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadMedicineOptions}
                              defaultOptions
                              value={row?.medicine}
                              onChange={(option) =>
                                handleMedicineChange(option, index)
                              }
                              placeholder="Select Medicine"
                              isDisabled={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Batch No."
                              value={row?.batchNumber}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "batchNumber",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Exp Dt"
                              value={row?.expiryDate?.split("T")[0]}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "expiryDate",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Qty"
                              value={row?.quantity}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "quantity",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Free Qty"
                              value={row?.freeQuantity}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "freeQuantity",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="MRP"
                              value={row?.mrp}
                              readOnly // optional to prevent manual changes
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="RMRP"
                              value={row?.rmrp}
                              readOnly // optional to prevent manual changes
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Margin(%)"
                              value={row?.margin}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "margin",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Rate"
                              value={row?.rate}
                              readOnly // optional to prevent manual changes
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Disc(%)"
                              value={row?.discount}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "discount",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <input type="hidden" value={row?.discountValue} />
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.taxable}
                              readOnly
                            />
                          </td>
                          <input type="hidden" value={row?.taxRate} />
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.cgst}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.sgst}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.total}
                              readOnly
                            />
                          </td>

                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              {medicineRows?.length > 1 &&
                                modalAction !== "edit" &&
                                modalAction !== "refund" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => removeMedicineRow(index)}
                                  >
                                    <FaMinusCircle />
                                  </button>
                                )}
                              {index === medicineRows?.length - 1 &&
                                modalAction !== "edit" &&
                                modalAction !== "refund" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success"
                                    onClick={addMedicineRow}
                                  >
                                    <FaPlusCircle />
                                  </button>
                                )}
                              {medicineRows?.length >= 1 &&
                                modalAction === "refund" && (
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${
                                      row?.isRefundEditing
                                        ? "btn-success"
                                        : "btn-warning"
                                    }`}
                                    disabled={row?.refundStatus === "Returned"}
                                  >
                                    {row?.isRefundEditing &&
                                    row?.refundStatus !== "Returned" ? (
                                      <FaSave />
                                    ) : (
                                      <FaUndo />
                                    )}
                                  </button>
                                )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="row justify-content-end mt-3">
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="fw-bold">Subtotal:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={calculateSubtotal().toFixed(2)}
                        readOnly
                      />
                    </div>
                    {/* <div className="mb-2">
                      <label className="fw-bold">Discount:</label>
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Discount"
                          value={discountValue}
                          onChange={(e) => setDiscountValue(e.target.value)}
                          readOnly={
                            (modalAction === "edit" &&
                              salesFormData?.paymentStatus === "PAID") ||
                            modalAction === "refund"
                              ? true
                              : false
                          }
                        />
                        {(modalAction !== "edit" && salesFormData?.paymentStatus !== "PAID") &&
                          modalAction !== "refund" && (
                        <select
                          className="form-select"
                          value={discountType}
                          onChange={(e) => setDiscountType(e.target.value)}
                          disabled={
                            (modalAction === "edit" &&
                              salesFormData?.paymentStatus === "PAID") ||
                            modalAction === "refund"
                          }
                        >
                          <option value="amount">₹</option>
                          <option value="percent">%</option>
                        </select>
                         )} 
                      </div>
                    </div> */}
                    {/* <div>
                      <label className="fw-bold">Net Total:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={netTotal}
                        readOnly
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={salesFormData?.isAlreadyPaid === true}
              >
                {modalAction === "edit" || modalAction === "refund"
                  ? "Update"
                  : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <AddUpdateRetailerModal
        modalVisible={showRetailerModal}
        setModalVisible={setShowRetailerModal}
        formData={retailerFormData}
        setFormData={setRetailerFormData}
        inputError={inputError}
        setInputError={setInputError}
        dispatch={dispatch}
        resetForm={resetForm}
        cities={cities}
        Country={Country}
        state={state}
        districts={districts}
        handleFileChange={handleFileChange}
        handleSelectChange={handleRetailerSelectChange}
        handleChange={handleChange}
        handleAddPatient={handleAddRetailer}
        fieldErrors={fieldErrors}
        setFieldErrors={setFieldErrors}
      />
    </>
  );
};

export default AddUpdatePharmaSalesRetailer;
